import { useIdentityAuth } from '../auth';
import { Roles } from '../utils/Constants';

// Archiving MATs and schools is a Super Admin decision. The API enforces it; this only keeps
// the controls hidden from everyone else, including while the identity is still loading.
export function useCanArchive() {
  const { loading, hasRole } = useIdentityAuth();
  return !loading && hasRole(Roles.SuperAdmin);
}
